namespace $ {

	export class $shm_hitalama_map_access_remote extends $mol_object {

		@ $mol_mem_key
		static options( body: string ): RequestInit {
			return { method: 'POST', body, cache: 'no-store', headers: { 'content-type': 'application/json' } }
		}

		@ $mol_mem_key
		static packet( buffer: ArrayBuffer ) { return new Uint8Array( buffer ) }

		@ $mol_mem_key
		static snapshot( [ auth, map, time, uri, revision ]: readonly [ $giper_baza_auth, string, number, string, number? ] ) {
			const body = this.$.$shm_hitalama_map_access_request.signed([ auth, map, time ])
			const response = this.$.$mol_wire_sync( this.$.$mol_fetch ).response( uri, this.options( body ) )
			if( response.code() === 404 ) return null
			if( !response.ok() ) $mol_fail( new Error( 'Не удалось проверить права на карту', { cause: response.code() } ) )
			const buffer = response.buffer()
			const packet = this.packet( buffer )
			const link = this.$.$mol_wire_sync( this.$.$giper_baza_link ).check( map )!
			return this.$.$shm_hitalama_map_access_proof.verify([ link, packet ])
		}

	}

}
